import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PortfolioDetailsPages from "../components/PortfolioDetails";

const PortfolioDetailsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Portfolio Details" />

        {/* DashBoardLayerTwo */}
        <PortfolioDetailsPages />

      </MasterLayout>
    </>
  );
};

export default PortfolioDetailsPage;
